/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { Check } from "lucide-react";

export function TarifsGrid({ pays, roleFilter, compact, testPrefix = "tarif" }) {
  const [g, setG] = useState(null);
  useEffect(() => { axios.get(`${API}/tarifs${pays ? `?pays=${pays}` : ""}`).then(({ data }) => setG(data)).catch(() => setG(null)); }, [pays]);
  if (!g) return null;
  const offres = g.offres.filter((o) => !roleFilter || o.role === roleFilter);
  return (
    <div data-testid={`${testPrefix}-grid`} className={`grid gap-3 ${compact ? "grid-cols-1" : "sm:grid-cols-2 lg:grid-cols-4"}`}>
      {offres.map((o) => (
        <div key={o.id} data-testid={`${testPrefix}-${o.id}`} className={`rounded-2xl border p-4 ${o.id === "kine" ? "bg-[#0A1426] text-white border-[#0A1426]" : "bg-white text-[#0A1426] border-[#E4E0D5]"}`}>
          <div className="text-[11px] uppercase tracking-wider font-bold opacity-70">{o.nom}</div>
          <div className="font-[Fraunces] text-3xl font-bold mt-1">{o.prix.toFixed(2).replace(".", ",")} {g.symbole}<span className="text-sm font-normal opacity-70"> / {o.periode}</span></div>
          <div className="text-[11px] opacity-70">{o.essai_jours ? `${o.essai_jours} jours d'essai gratuit` : "Sans engagement"}{g.mobile_money ? " · Mobile Money" : ""}</div>
          {!compact && <ul className="mt-2 flex flex-col gap-1">{o.inclus.map((i) => <li key={i} className="text-[12px] flex items-start gap-1.5"><Check size={13} className={o.id === "kine" ? "text-[#D4AF5A] mt-0.5" : "text-[#2BA3A0] mt-0.5"} /> {i}</li>)}</ul>}
        </div>
      ))}
      {g.pays_nom && <div className="col-span-full text-[11px] text-[#0A1426]/60">Tarifs {g.pays_nom} en {g.devise}. Code promo ou parrainage BC-XXXXXX applicable à l'inscription.</div>}
    </div>
  );
}
